// extracted by mini-css-extract-plugin
export var cardIcon = "_6o-5";
export var cardIconUnframed = "_6o-9";
export var checkboxCard = "_6o-0";
export var checkboxCardSelected = "_6o-4";
export var disabled = "_6o-2";
export var interactive = "_6o-1";
export var outerBorder = "_6o-3";
export var spacerMedium = "_6o-8";
export var spacerSmall = "_6o-7";
export var spacerXsmall = "_6o-6";